import { PolymorphicComponentProps } from "@omni/types/components/utils/polymorphic.types";
import React from "react";

import { card } from "../../card.style";
import { useCardContext } from "../../context/card.context";

export type CardImageProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, {}, "img">;

const CardImage = <T extends React.ElementType = "img">({
    className,
    tag,
    ...attributes
}: CardImageProps<T>) => {
    const { imgAlignment, border } = useCardContext();

    const Tag = tag || ("img" as React.ElementType);
    const { image } = card({ imgAlignment, border });

    return (
        <Tag
            {...attributes}
            className={image({ className })}
        />
    );
};

export { CardImage };
